import { render, staticRenderFns } from "./AdminImports.vue?vue&type=template&id=7bd7fea4"
import script from "./AdminImports.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminImports.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/administrations/locales/i18n-admin-imports.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fadministrations%2FImport%2FAdminImports.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports